import { req, reqPost } from './axiosFun';
const BASE_URL = "";

/**
 * 操作日志
 **/
// 分页查询
export const operationLogPage = (params) => { return reqPost(BASE_URL + "/api/operationLog/page", params) };
// 详情（字段差异、能否回滚）
export const operationLogDetail = (logId) => { return req('get', BASE_URL + "/api/operationLog/" + logId, null) };
// 回滚
export const operationLogRollback = (logId) => { return reqPost(BASE_URL + "/api/operationLog/" + logId + "/rollback", {}) };



// WEBPACK FOOTER //
// ./src/api/operationLog.js